module.exports = __webpack_public_path__ + "static/media/line-chart.ac442886.png";